import { Box, Typography, useTheme } from '@mui/material';
import ExpandableBox from 'src/components/common/ExpandableBox';
import FlagCountry from 'src/components/common/FlagCountry';
import TableHorizontal from 'src/components/TableHorizontal';

const NotifyParty = ({ tradeDataDetail }: { tradeDataDetail: IBillOfLadingDetail }) => {
  const {
    palette: { background },
    shape,
  } = useTheme();
  return (
    <ExpandableBox title="Notify Party" openDefault={true} flex={1}>
      <Box
        padding={3}
        display="flex"
        flexDirection="column"
        bgcolor={background.default}
        borderRadius={`0px 0px ${shape.borderRadius * 2}px ${shape.borderRadius * 2}px`}
      >
        <TableHorizontal
          colKeyWidth={350}
          configColumn={[
            {
              label: 'Notify Party',
              renderCell(data: IBillOfLadingDetail) {
                return (
                  <Typography variant="body2" color={'text.secondary'}>
                    {data.transaction?.notify_party_name}
                  </Typography>
                );
              },
            },
            {
              label: 'Notify Party Country',
              renderCell(data) {
                return (
                  <Typography variant="body2" color={'text.secondary'}>
                    <FlagCountry width={24} code={data.transaction?.notify_country_code} />
                    {data.transaction?.notify_country_name}
                  </Typography>
                );
              },
            },
            {
              label: 'Notify Party Address',
              renderCell(data) {
                return (
                  <Typography variant="body2" color={'text.secondary'}>
                    <FlagCountry width={24} code={data.transaction?.notify_country_code} />
                    {data.transaction?.notify_party_address}
                  </Typography>
                );
              },
            },
          ]}
          data={tradeDataDetail}
        />
      </Box>
    </ExpandableBox>
  );
};

export default NotifyParty;
